module.exports = __webpack_public_path__ + "static/media/Data_Processing.176dc89f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/resources/Data_Processing.png
// module id = 986
// module chunks = 0